import { RiCalendar2Line, RiCalendarTodoLine } from "@remixicon/react";

const viewConfig = {
  month: {
    icon: RiCalendar2Line,
    label: "Month",
  },
  week: {
    icon: RiCalendarTodoLine,
    label: "Week",
  },
};

const CalendarHeader = ({
  monthYearDisplay,
  weekInfo,
  viewMode,
  onViewToggle,
}) => {
  const { icon: Icon, label } = viewConfig[viewMode];
  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-col">
        <h3 className="text-lg font-semibold text-gray-900">
          {monthYearDisplay}
        </h3>
        <p className="text-sm text-gray-500">{weekInfo}</p>
      </div>
      <button
        onClick={onViewToggle}
        className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-gray-700 border border-gray-500 rounded-full hover:bg-gray-50"
      >
        <>
          <Icon className="w-4 h-4 text-black" />
          {label}
        </>
      </button>
    </div>
  );
};

export default CalendarHeader;
